import { render, staticRenderFns } from "./Wp_join_robot_status_tag_model.vue?vue&type=template&id=fdb2e890&scoped=true&"
import script from "./Wp_join_robot_status_tag_model.vue?vue&type=script&lang=js&"
export * from "./Wp_join_robot_status_tag_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2e890",
  null
  
)

export default component.exports